import { Link } from 'react-router-dom'
import { PageHeader } from '@/components/common/PageHeader'
import css from '@/components/common/Common.module.css'

export function SettingsPage() {
  return (
    <div>
      <PageHeader title="Settings" description="System configuration" />

      <div className={css.card}>
        <h3 style={{ fontSize: 'var(--text-base)', fontWeight: 600, marginBottom: 'var(--space-3)' }}>Organizations</h3>
        <p style={{ color: 'var(--color-text-muted)', fontSize: 'var(--text-sm)', marginBottom: 'var(--space-4)' }}>
          Manage distributor organizations, view users, orders, and revenue.
        </p>
        <Link to="/admin/organizations" className={css.btnPrimary}>
          Go to Organizations
        </Link>
      </div>
    </div>
  )
}
